import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Clock } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/site/Logo";

export default function Footer() {
  const { t, tx, siteInfo } = useApp();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-brand text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-5">
          <Logo dark />
          <p className="text-slate-400 max-w-sm leading-relaxed text-sm">{t.hero.sub}</p>
        </div>
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest text-slate-500 mb-4">{t.footer.nav}</h4>
          <ul className="space-y-2.5 text-sm text-slate-300">
            <li><Link to="/leistungen" className="hover:text-white transition-colors">{t.nav.services}</Link></li>
            <li><Link to="/projekte" className="hover:text-white transition-colors">{t.nav.gallery}</Link></li>
            <li><Link to="/ueber-uns" className="hover:text-white transition-colors">{t.nav.about}</Link></li>
            <li><Link to="/kontakt" className="hover:text-white transition-colors">{t.nav.contact}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-bold text-sm uppercase tracking-widest text-slate-500 mb-4">{t.footer.contact}</h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex gap-2.5"><MapPin size={16} className="mt-0.5 shrink-0 text-accent2" /><span>{tx(siteInfo.address)}</span></li>
            {(siteInfo.contacts || []).map((c) => (
              <li key={c.phone} className="flex gap-2.5">
                <Phone size={16} className="mt-0.5 shrink-0 text-accent2" />
                <span>{c.name}<br /><a href={`tel:${(c.phone||'').replace(/\s/g,'')}`} className="hover:text-white">{c.phone}</a></span>
              </li>
            ))}
            <li className="flex gap-2.5"><Mail size={16} className="mt-0.5 shrink-0 text-accent2" /><a href={`mailto:${siteInfo.email}`} className="hover:text-white">{siteInfo.email}</a></li>
            <li className="flex gap-2.5"><Clock size={16} className="mt-0.5 shrink-0 text-accent2" /><span className="whitespace-pre-line">{tx(siteInfo.hours)}</span></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <span>© {year} AM-Montage. {t.footer.rights}</span>
          <div className="flex gap-5">
            <Link to="/impressum" className="hover:text-white transition-colors">{t.footer.imprint}</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">{t.footer.privacy}</Link>
            <Link to="/admin/login" className="hover:text-white transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
